import { toast } from 'react-toastify';
import { generalValidationFunction } from '../mle.validation';
import { ATLEAST_ONE, MAXIMUM_VALUE, MINIMUM_VALUE, MLE_CREATE_FORM_NAME, mleFields, PREFIX_KYCURLS,getMleFields } from './contants';
import { FORM_ERRORS, KYC_FILES } from '../mle.constants';
import { isAllErrorFixed, setFieldValue } from '../mle.utils';
import { fieldLevelValidators } from 'utils/validators';
import { businessType } from 'components/MerchantTab/constant';

const ATLEAST = (val) => `Value must be at least ${val}. `;
const EXCEED = (val) => `Value must not exceed ${val}. `;


const validateDocs = (documents, errors, setFieldValue, editedDocCategory, infoMsgs) => {
    if (!documents || !Array.isArray(documents)) return;
    
    editedDocCategory.map(category => {
        let mandatoryDocs = documents?.filter(item => category.includes(item?.docCategory));

        let mandatoryDocsKeys = mandatoryDocs.map(item => item.docType);
    
        let infoMsgsfiltered = Object.keys(infoMsgs)?.filter(item => mandatoryDocsKeys.includes(item?.split('.')[1]));
    
        if (infoMsgsfiltered?.length === 0) {
            for (const item of mandatoryDocs) {
                if (setFieldValue && typeof setFieldValue === "function") {
                    setFieldValue(errors, `${KYC_FILES}.${item.docType}`, ATLEAST_ONE(category));
                }
            }
        }
    })
    
}

const validate = (values, props, basicData) => {
    try {
        
        const errors = generalValidationFunction(values,  getMleFields(values.businessType, values?.optionalFields));    
        
        if (values?.[MINIMUM_VALUE] && values?.[mleFields.turnoverAmount.name] < values?.[MINIMUM_VALUE]) {
            setFieldValue(errors, mleFields.turnoverAmount.name, ATLEAST(values[MINIMUM_VALUE]));
        }
        if (values?.[MAXIMUM_VALUE] && values?.[mleFields.turnoverAmount.name] > values?.[MAXIMUM_VALUE]) {
            setFieldValue(errors, mleFields.turnoverAmount.name, EXCEED(values[MAXIMUM_VALUE]));
        }
        if (values?.mandatoryDocs && Array.isArray(values?.mandatoryDocs)) {
            for (let i = 0; i < values.mandatoryDocs.length; i++) {
                let item = values.mandatoryDocs[i];
                if (item?.docType) {
                    // errors[`${KYC_FILES}.${item.docType}`] = fieldLevelValidators.required(values?.[PREFIX_KYCURLS]?.[item.docType]);
                    if (item?.maxDocCount > 1) {
                        let valueExist = values?.[PREFIX_KYCURLS]?.[item.docType]?.length > 0 ? 'exist': null;
                        setFieldValue(errors, `${KYC_FILES}.${item.docType}`, fieldLevelValidators.required(valueExist));
                    }
                    else 
                        setFieldValue(errors, `${KYC_FILES}.${item.docType}`, fieldLevelValidators.required(values?.[KYC_FILES]?.[item.docType] || null));
                }
            }
        }
        
        if (values?.editedDocCategory && Array.isArray(values?.editedDocCategory) && values?.editedDocCategory?.length > 0) {
            // logic 
            // doc category | mandatoryDocs | infoMsgs
            // filter mandatory docs | find docs based on category
            // if infoMsg contains filter doc category --- no error
            // else error
            const mandatoryDocs = Array.isArray(values?.mandatoryDocs) ? values.mandatoryDocs : [];
            const partiallyMandatoryDocs = Array.isArray(values?.partiallyMandatoryDocs) ? values.partiallyMandatoryDocs : [];
    
            validateDocs([...mandatoryDocs, ...partiallyMandatoryDocs], errors, setFieldValue, values?.editedDocCategory ?? [], values?.infoMsgs ?? {});
    
        }
        
        // if (errors.address) delete errors.address;
        if (errors && !isAllErrorFixed(errors)){
            
            return errors;
            // toast.error(FORM_ERRORS);
            // props.stopSubmit(MLE_CREATE_FORM_NAME, errors);
        } else {
            return {};
        }
    } 
    catch (error) {
        console.error('Error in validation:', error);
        return {};
    }
};

export default validate;
